import React from 'react'

export const FocusBoxSettings = props => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}
